/**
 * 当前前端使用的固定积分汇率：
 * - 1 credit = $0.01
 * - 1 USD = 100 credits
 *
 * 之前通过 `/api/credits/price` / `/api/credits/rate` 拉取，
 * 但目前产品逻辑固定，因此改为本地常量以避免频繁网络请求（如新建节点时）。
 */
import { ceilCredits } from '@flowmuse/models/cost/credits';

export const DEFAULT_CREDIT_VALUE_USD = 0.01;

/**
 * 与后端 `/api/credits/price` 返回结构对齐的固定值。
 */
export const DEFAULT_PRICE_INFO = {
  unitPriceCents: 100,
  creditsPerUnit: 100,
  currency: 'usd',
} as const;

export function usdToCredits(usdCost: number, creditValueUsd = DEFAULT_CREDIT_VALUE_USD) {
  // 与右侧面板逻辑保持一致：向上取整，且至少为 1
  // 用 ceilCredits 而非 raw Math.ceil 以去除浮点噪声（例如 0.08 / 0.01 = 8.000000000000002）。
  return Math.max(0.01, ceilCredits(usdCost / creditValueUsd, 2));
}


